export default __webpack_public_path__ + "static/media/h-w-1.6924f1a5.svg";